const ClearAllSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <mask id="mask0_7443_26216" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_7443_26216)">
        <path d="M5 5L11 11" stroke="#D5D5D5" strokeLinecap="round" />
        <path d="M11 5L5 11" stroke="#D5D5D5" strokeLinecap="round" />
      </g>
    </svg>
  );
};

export default ClearAllSvg;
